// @flow
const settingsState: Object = {
  apikey: '',
  endpoint: '',
  select: () => {},
};

export default settingsState;
